import lazyScreen from '../utils/lazyScreen';
const MFProceduces = lazyScreen(() => import('../pages/mf/MFProceduces/index.js'), 'pages/mf/MFProceduces/index.js');
const MFProceduce = lazyScreen(() => import('../pages/mf/MFProceduce/index.js'), 'pages/mf/MFProceduce/index.js');
const MFBOMs = lazyScreen(() => import('../pages/mf/MFBOMs/index.js'), 'pages/mf/MFBOMs/index.js');
const MFBOM = lazyScreen(() => import('../pages/mf/MFBOM/index.js'), 'pages/mf/MFBOM/index.js');
const MFMDSTickets = lazyScreen(() => import('../pages/mf/MFMDSTickets/index.js'), 'pages/mf/MFMDSTickets/index.js');
const MFMDSTicket = lazyScreen(() => import('../pages/mf/MFMDSTicket/index.js'), 'pages/mf/MFMDSTicket/index.js');
const MFMDSSummarys = lazyScreen(() => import('../pages/mf/MFMDSSummarys/index.js'), 'pages/mf/MFMDSSummarys/index.js');
const MFMDSSummary = lazyScreen(() => import('../pages/mf/MFMDSSummary/index.js'), 'pages/mf/MFMDSSummary/index.js');
const MFMDSSummaryItem = lazyScreen(() => import('../pages/mf/MFMDSSummaryItem/index.js'), 'pages/mf/MFMDSSummaryItem/index.js');
const MFMPSs = lazyScreen(() => import('../pages/mf/MFMPSs/index.js'), 'pages/mf/MFMPSs/index.js');
const MFMPS = lazyScreen(() => import('../pages/mf/MFMPS/index.js'), 'pages/mf/MFMPS/index.js');
const MFMRPSummarys = lazyScreen(() => import('../pages/mf/MFMRPSummarys/index.js'), 'pages/mf/MFMRPSummarys/index.js');
const MFMRPSummary = lazyScreen(() => import('../pages/mf/MFMRPSummary/index.js'), 'pages/mf/MFMRPSummary/index.js');
const MFMakeOrders = lazyScreen(() => import('../pages/mf/MFMakeOrders/index.js'), 'pages/mf/MFMakeOrders/index.js');
const MFMakeOrder = lazyScreen(() => import('../pages/mf/MFMakeOrder/index.js'), 'pages/mf/MFMakeOrder/index.js');
const MFWorkTickets = lazyScreen(() => import('../pages/mf/MFWorkTickets/index.js'), 'pages/mf/MFWorkTickets/index.js');
const MFWorkTicket = lazyScreen(() => import('../pages/mf/MFWorkTicket/index.js'), 'pages/mf/MFWorkTicket/index.js');
const MFMaterialIssue = lazyScreen(() => import('../pages/mf/MFMaterialIssue/index.js'), 'pages/mf/MFMaterialIssue/index.js');
const MFMaterialIssues = lazyScreen(() => import('../pages/mf/MFMaterialIssues/index.js'), 'pages/mf/MFMaterialIssues/index.js');
const MFReworkTicket = lazyScreen(() => import('../pages/mf/MFReworkTicket/index.js'), 'pages/mf/MFReworkTicket/index.js');
const MFReworkTickets = lazyScreen(() => import('../pages/mf/MFReworkTickets/index.js'), 'pages/mf/MFReworkTickets/index.js');
const MFCostConfig = lazyScreen(() => import('../pages/mf/MFCostConfig/index.js'), 'pages/mf/MFCostConfig/index.js');
const MFCostConfigs = lazyScreen(() => import('../pages/mf/MFCostConfigs/index.js'), 'pages/mf/MFCostConfigs/index.js');
const MFCosting = lazyScreen(() => import('../pages/mf/MFCosting/index.js'), 'pages/mf/MFCosting/index.js');
const MFCostings = lazyScreen(() => import('../pages/mf/MFCostings/index.js'), 'pages/mf/MFCostings/index.js');
const MFShiftRoster = lazyScreen(() => import('../pages/mf/MFShiftRoster/index.js'), 'pages/mf/MFShiftRoster/index.js');
const MFShiftRosters = lazyScreen(() => import('../pages/mf/MFShiftRosters/index.js'), 'pages/mf/MFShiftRosters/index.js');
const MFLaborSheet = lazyScreen(() => import('../pages/mf/MFLaborSheet/index.js'), 'pages/mf/MFLaborSheet/index.js');
const MFLaborSheets = lazyScreen(() => import('../pages/mf/MFLaborSheets/index.js'), 'pages/mf/MFLaborSheets/index.js');
const MFAndonBoard = lazyScreen(() => import('../pages/mf/MFAndonBoard/index.js'), 'pages/mf/MFAndonBoard/index.js');

export default [
    {
        path: '/mf/MFAndonBoard',
        component: MFAndonBoard
    },
    {
        path: '/mf/MFProceduce/:code',
        component: MFProceduce
    },
    {
        path: '/mf/MFProceduces',
        component: MFProceduces
    },
    {
        path: '/mf/MFBOM/:code',
        component: MFBOM
    },
    {
        path: '/mf/MFBOMs',
        component: MFBOMs
    },
    {
        path: '/mf/MFMDSTicket/:code',
        component: MFMDSTicket
    },
    {
        path: '/mf/MFMDSTickets',
        component: MFMDSTickets
    },
    {
        path: '/mf/MFMDSSummary/:code',
        component: MFMDSSummary
    },
    {
        path: '/mf/MFMDSSummaryItem/:id',
        component: MFMDSSummaryItem
    },
    {
        path: '/mf/MFMDSSummarys',
        component: MFMDSSummarys
    },
    {
        path: '/mf/MFMPS/:code',
        component: MFMPS
    },
    {
        path: '/mf/MFMPSs',
        component: MFMPSs
    },
    {
        path: '/mf/MFMRPSummary/:code',
        component: MFMRPSummary
    },
    {
        path: '/mf/MFMRPSummarys',
        component: MFMRPSummarys
    },
    {
        path: '/mf/MFMakeOrder/:code',
        component: MFMakeOrder
    },
    {
        path: '/mf/MFMakeOrders',
        component: MFMakeOrders
    },
    {
        path: '/mf/MFWorkTicket/:code',
        component: MFWorkTicket
    },
    {
        path: '/mf/MFWorkTickets',
        component: MFWorkTickets
    },
    // {
    //     path: '/mf/MFWorkTicketActivity',
    //     component: MFWorkTicketActivity
    // },
    // {
    //     path: '/mf/MFWorkMoves',
    //     component: MFWorkMoves
    // },
    // {
    //     path: '/mf/MFWorkFinishs',
    //     component: MFWorkFinishs
    // },
    // {
    //     path: '/mf/MFWorkSemiFinishs',
    //     component: MFWorkSemiFinishs
    // },
    {
        path: '/mf/MFMaterialIssue/:code',
        component: MFMaterialIssue
    },
    {
        path: '/mf/MFMaterialIssues',
        component: MFMaterialIssues
    },
    {
        path: '/mf/MFReworkTicket/:code',
        component: MFReworkTicket
    },
    {
        path: '/mf/MFReworkTickets',
        component: MFReworkTickets
    },
    {
        path: '/mf/MFCostConfig/:code',
        component: MFCostConfig
    },
    {
        path: '/mf/MFCostConfig',
        component: MFCostConfig
    },
    {
        path: '/mf/MFCostConfigs',
        component: MFCostConfigs
    },
    {
        path: '/mf/MFCosting/:code',
        component: MFCosting
    },
    {
        path: '/mf/MFCostings',
        component: MFCostings
    },
    {
        path: '/mf/MFShiftRoster/:code',
        component: MFShiftRoster
    },
    {
        path: '/mf/MFShiftRosters',
        component: MFShiftRosters
    },
    {
        path: '/mf/MFLaborSheet/:code',
        component: MFLaborSheet
    },
    {
        path: '/mf/MFLaborSheets',
        component: MFLaborSheets
    }
];
